'use strict';

const LINKEDIN_ACCOUNT_STATUS_CONSTANTS = {
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  INVITATION_SEND_ERROR: 'LINKEDIN_INVITATION_SEND_ERROR',
  MESSAGE_SEND_ERROR: 'LINKEDIN_MESSAGE_SEND_ERROR',
  USER_PROFILE_FETCH_ERROR: 'LINKEDIN_USER_PROFILE_FETCH_ERROR',
  SUCCESS: 'SUCCESS',
};

const LINKEDIN_MAX_ACTION_LIMIT = {
  PREMIUM: 40,
  FREE: 30,
};

export {
  LINKEDIN_ACCOUNT_STATUS_CONSTANTS,
  LINKEDIN_MAX_ACTION_LIMIT,
};
